/**
 * useRolePresets - roles defined in the database (role_presets) for selectors.
 *
 * Role codes and names are not hardcoded in the client: internal staff can
 * create roles from the Roles tab, so every picker has to read the same table.
 * There is intentionally no long-lived cache; requests in flight are shared so
 * two components mounting together make a single call, but once the list is
 * settled a new mount fetches again and picks up recently created roles.
 */
import { useEffect, useState } from 'react';
import AccountsUsersService from '../services/AccountsUsersService';

let inFlight = null;

function loadPresets() {
    if (!inFlight) {
        inFlight = AccountsUsersService.getRolePresets()
            .then((data) => (data && data.items) || [])
            .finally(() => {
                inFlight = null;
            });
    }
    return inFlight;
}

export function useRolePresets() {
    const [presets, setPresets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let alive = true;
        loadPresets()
            .then((items) => {
                if (!alive) return;
                setPresets(items);
                setLoading(false);
            })
            .catch((e) => {
                if (!alive) return;
                setError(e.message || 'No se pudieron cargar los roles');
                setLoading(false);
            });
        return () => {
            alive = false;
        };
    }, []);

    return { presets, loading, error };
}

export default useRolePresets;
